import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Money } from '../../../core/model/money';
import { ResidentialProperty } from '../../model/residential-property';

@Component({
    selector: 'app-residential-property-statistics',
    templateUrl: './residential-property-statistics.component.html',
    styleUrls: ['./residential-property-statistics.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResidentialPropertyStatisticsComponent implements OnInit {
  constructor() {}

  @Input() model: ResidentialProperty;

  get averageContractAge(): number {
    return this.model ? this.model.averageContractAge : null;
  }
  get nextMonthRent(): Money {
    return this.model ? this.model.nextMonthRent : null;
  }
  get totalSurface(): number {
    return this.model ? this.model.totalSurface : null;
  }

  ngOnInit() {}
}
